
export default {
  heroTitle: "منصة إعلانية متكاملة",
  heroSubtitle: "إعادة تصور",
  heroDescription: "وسّع تأثير علامتك التجارية بدقة من خلال الإعلانات الرقمية الآلية عبر الحلول الإعلانية الأكثر تأثيراً في المملكة العربية السعودية.",
  startCampaign: "ابدأ حملة",
  startAdvertising: "ابدأ الإعلان",
  
  // Features
  strategicLocations: "مواقع استراتيجية",
  strategicLocationsDesc: "ضع إعلاناتك في مناطق ذات حركة مرور عالية للحصول على أقصى قدر من الرؤية",
  smartTargeting: "استهداف ذكي",
  smartTargetingDesc: "استهدف فئات سكانية ومناطق محددة لحملتك",
  programmaticTechnology: "تكنولوجيا برمجية",
  programmaticTechnologyDesc: "استفد من التكنولوجيا المتطورة لتوصيل الإعلان الأمثل",
  
  // Features Grid
  whyChooseUs: "لماذا تختارنا",
  whyChooseUsDesc: "مبنية للمعلنين المتمرسين والطموحين الذين يطالبون بالنتائج والكفاءة والابتكار في حملاتهم.",
  
  // Value Proposition
  everyAdvertiserDream: "حلم كل معلن",
  everyAdvertiserDreamDesc: "اوصل لملايين الأشخاص بدقة برمجية وتحسين في الوقت الفعلي وتقارير شفافة - كل ذلك من منصة واحدة قوية.",
  
  // Stats
  digitalDisplays: "شاشات رقمية",
  dailyViews: "مشاهدات يومية",
  clientSatisfaction: "رضا العملاء",
  ourImpact: "تأثيرنا",
  ourImpactDesc: "موثوق من قبل المعلنين والمسوقين الذين يقدرون الأداء والوصول والنتائج القابلة للقياس.",
  
  // AI Technology Section
  worldsFirstTech: "أول تقنية في العالم",
  revolutionaryAI: "تقنية الذكاء الاصطناعي الثورية للإعلانات الرقمية الخارجية",
  aiTechDescription: "طورنا تقنية ذكاء اصطناعي رائدة مصممة خصيصاً للإعلانات الرقمية الخارجية. هذا الحل المبتكر هو الأول من نوعه عالمياً، ويوفر قدرات لا مثيل لها في تحسين الإعلانات الرقمية الخارجية البرمجية. يمكن لذكائنا الاصطناعي إنشاء الحملة بأكملها لك - من التخطيط الإعلامي الشامل إلى حسابات الميزانية الدقيقة - وتشغيلها تلقائياً.",
  completeCampaignCreation: "إنشاء حملة شاملة",
  completeCampaignDesc: "الذكاء الاصطناعي ينشئ تلقائياً خطط إعلامية، ويحسب الميزانيات، ويطلق الحملات دون تدخل يدوي",
  intelligentAutomation: "أتمتة ذكية",
  intelligentAutomationDesc: "من الاستراتيجية إلى التنفيذ، يتعامل ذكاؤنا الاصطناعي مع كل جانب من جوانب نشر الحملة وتحسينها",
  globalInnovation: "ابتكار عالمي",
  globalInnovationDesc: "أول تقنية ذكاء اصطناعي في العالم مصممة حصرياً لإدارة حملات الإعلانات الرقمية الخارجية من البداية إلى النهاية",
  newRelease: "🚀 إصدار جديد • أتمتة الحملة الكاملة من التخطيط إلى التنفيذ",
  
  // CTA Section
  readyToTransform: "مستعد لتحويل إعلاناتك؟",
  readyToTransformDesc: "انضم إلى آلاف المعلنين والمسوقين الذين يثقون في منصتنا لتقديم نتائج استثنائية ودفع المشاركة الهادفة.",
  createYourCampaign: "أنشئ حملتك",
} as const;
